const ShopActionTypes = {
  CHANGE_SEX: "CHANGE_SEX",
  FETCH_SHOP_PRODUCTS: "FETCH_SHOP_PRODUCTS",
}

export default ShopActionTypes
